export default {
  active_orders: {
    title: 'Ausstehende Bestellungen',
  },
  order_history: {
    title: 'Bestellhistorie',
  },
  menu: {
    title: 'Menü',
  },
  printer_settings: {
    title: 'Drucker Einstellungen',
  },
  order_control: {
    title: 'Bestelloptionen',
  },
  busy_mode: {
    title_zero: 'Busy Mode',
    title_other: 'Busy Mode (+{{time}} min)',
  },
  volume: {
    title: 'Lautstärke',
  },
  switch_language: {
    title: 'Sprache wechseln ({{language}})',
  },
  logout: {
    title: 'Ausloggen',
    description: 'Bist du sicher, dass du dich abmelden möchtest?',
    buttons: {
      confirm: 'Ja',
      cancel: 'Abbrechen',
    },
  },
  test_restaurant: {
    label: 'Test',
    tooltip: 'Testrestaurant: Bestellungen hier sind Tests, und es wird nie abgerechnet.',
  },
};
